const hamburger = document.querySelector('.a-hamburger');
const mobileMenu = document.querySelector('.m-nav--mobile');

hamburger.addEventListener('click', () => {
  if (!mobileMenu.classList.contains('open')) {
    mobileMenu.classList.add('open');
    hamburger.classList.add('open');
  } else {
    mobileMenu.classList.remove('open');
    hamburger.classList.remove('open');
  }
});
